import { INote } from "../interfaces/user.interface";

export const countScoreAverage = (notes: INote[]): string => {
    const sum = notes.reduce((total: number, note: INote) => note.vote + total, 0);
    const average = sum / notes.length;

    return !isNaN(average) ? average.toFixed(1) : '5';
}